module.exports = __webpack_public_path__ + "static/media/paste.93e5dfbb.ico";